import { makeAutoObservable } from 'mobx'
import {
  ChatbotFollowUpAssertiveness,
  type IChatbotFollowUpAssertiveness,
  type IChatbotSettings,
} from '../type'

export class ChatbotAutoFollowUp {
  static DefaultFollowUpWindow = 3
  static DefaultSessionLifetime = 1

  enabled = true
  followUpWindow = ChatbotAutoFollowUp.DefaultFollowUpWindow
  assertiveness: IChatbotFollowUpAssertiveness = ChatbotFollowUpAssertiveness.Steady
  sessionLifetime = ChatbotAutoFollowUp.DefaultSessionLifetime

  constructor() {
    makeAutoObservable(this)
  }

  setEnabled = (value: boolean) => {
    if (!value) {
      this.assertiveness = ChatbotFollowUpAssertiveness.Steady
      this.followUpWindow = ChatbotAutoFollowUp.DefaultFollowUpWindow
    } else {
      this.sessionLifetime = ChatbotAutoFollowUp.DefaultSessionLifetime
    }
    this.enabled = value
  }

  setFollowUpWindow = (value: number) => {
    this.followUpWindow = value
  }

  setAssertiveness = (value: IChatbotFollowUpAssertiveness) => {
    this.assertiveness = value
  }

  setSessionLifetime = (value: number) => {
    this.sessionLifetime = value
  }

  syncOrigin(settings?: IChatbotSettings | null) {
    this.enabled = settings?.enable_followup?.value ?? true
    this.followUpWindow =
      settings?.followup_window?.value ?? ChatbotAutoFollowUp.DefaultFollowUpWindow
    this.assertiveness =
      settings?.followup_assertiveness?.value ?? ChatbotFollowUpAssertiveness.Steady
    this.sessionLifetime =
      settings?.session_lifetime?.value ?? ChatbotAutoFollowUp.DefaultSessionLifetime
  }

  toJSON(): Pick<
    IChatbotSettings,
    'enable_followup' | 'followup_window' | 'followup_assertiveness' | 'session_lifetime'
  > {
    return {
      enable_followup: { value: this.enabled },
      followup_window: { value: this.followUpWindow },
      followup_assertiveness: { value: this.assertiveness },
      session_lifetime: { value: this.sessionLifetime },
    }
  }
}
